import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

import { IonCard, IonCardContent, IonCardHeader, IonCardSubtitle, IonCardTitle, IonLabel, IonList, IonItem } from "@ionic/vue";
import { onMounted, ref } from "vue";
import { useMotion } from "@vueuse/motion";


export default /*@__PURE__*/_defineComponent({
  __name: 'ListCard',
  props: {
  subTitle: {
    type: String,
    required: true
  },
  title: {
    type: String,
    required: false
  },
  value: {
    type: Object,
    required: true
  },
  suffix: {
    type: String,
    required: false
  }
},
  setup(__props) {



const card = ref()

const { variant } = useMotion(card, {
  initial: {
    opacity: 0,
    y: 100
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 300,
      type: 'keyframes',
      ease: 'easeIn',
    },
  }
})


return (_ctx: any,_cache: any) => {
  const _directive_motion = _resolveDirective("motion")!

  return (__props.value.length)
    ? (_openBlock(), _createBlock(_unref(IonCard), {
        key: 0,
        ref_key: "card",
        ref: card,
        class: "ion-margin"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(IonCardHeader), null, {
            default: _withCtx(() => [
              _createVNode(_unref(IonCardSubtitle), null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(__props.subTitle), 1)
                ]),
                _: 1
              }),
              _createVNode(_unref(IonCardTitle), null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(__props.title), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_unref(IonCardContent), null, {
            default: _withCtx(() => [
              _createVNode(_unref(IonList), null, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.value, (repo) => {
                    return _withDirectives((_openBlock(), _createBlock(_unref(IonItem), {
                      lines: "none",
                      initial: {
            opacity: 0,
            x: 100
          },
                      visible: {
            opacity: 1,
            x: 0,
            transition: {
              duration: 300,
              type: 'keyframes',
              ease: 'easeIn',
            }
          },
                      key: repo.TableItemSeqId
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(repo.TableItemSeqId) + ". " + _toDisplayString(repo.TableItemLabel) + " ", 1),
                        (repo.TableItemMeta)
                          ? (_openBlock(), _createBlock(_unref(IonLabel), {
                              key: 0,
                              slot: "end"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(repo.TableItemMeta) + " " + _toDisplayString(__props.suffix ? repo.TableItemMeta == 1 ? __props.suffix : __props.suffix + "s" : ""), 1)
                              ]),
                              _: 2
                            }, 1024))
                          : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1024)), [
                      [_directive_motion]
                    ])
                  }), 128))
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 512))
    : _createCommentVNode("", true)
}
}

})